/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Alpine from 'alpinejs';
import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import Headermenu from './navigation/navigation';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import NumberAnimation from './modules/number-animation';
import SliderHero from './classes/slider-hero';
import VueApplication from './modules/components';
import SliderFinn from './classes/slider-finn';
import CardsOccupation from "./modules/cards-occupation";
import CollapseFiona from "./modules/collapse-fiona";
import SliderLogos from "./classes/slider-logos";
import ResponsiveImage from "./modules/responsive-image";
import CoursesSearch from './modules/courses-search';

require('intersection-observer');
IntersectionObserver.prototype.POLL_INTERVAL = 100;

const siteInitialization = () => {
	VueApplication.init();

	Form.init();
	Accordion.init();
	CookieByte.init();
	Headermenu.init();
	MediaViewer.init();
	ImageGallery.init();
	SliderHero.initAll();
	SliderFinn.initAll();
	SliderLogos.initAll();
	NumberAnimation.init();
	CardsOccupation.initAll();
	CollapseFiona.initAll();
	ResponsiveImage.initAll();
	CoursesSearch.init();
	window.Alpine = Alpine;
	Alpine.start();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
